/**
 * Typed event names and helpers used across the app so GA dashboards stay
 * stable as features evolve. Keep names lowercase_snake_case (GA4 convention).
 */

import { trackEvent } from "./ga";

export const AnalyticsEvents = {
  // Auth
  signUp: (method: string) => trackEvent("sign_up", { method }),
  login: (method: string) => trackEvent("login", { method }),

  // Practice (generic across all kinds)
  practiceStarted: (params: { kind_id: string; topic_id?: string; grade?: string }) =>
    trackEvent("practice_started", params),
  practiceCompleted: (params: {
    kind_id: string;
    topic_id?: string;
    grade?: string;
    score?: number;
    won?: boolean;
  }) => trackEvent("practice_completed", params),

  // AI game generation
  aiGameGenerateRequested: (params: {
    topic_id?: string;
    grade?: string;
    difficulty?: string;
  }) => trackEvent("ai_game_generate_requested", params),
  aiGameGenerateSucceeded: (params: {
    game_id: string;
    grade?: string;
    from_cache?: boolean;
  }) => trackEvent("ai_game_generate_succeeded", params),
  aiGameGenerateFailed: (params: {
    reason: "engine" | "safety" | "grade" | "api_error" | "rate_limit" | "payment";
    grade?: string;
  }) => trackEvent("ai_game_generate_failed", params),

  // Game play lifecycle
  gamePlayStarted: (params: { game_id: string; grade?: string }) =>
    trackEvent("game_play_started", params),
  gamePlayCompleted: (params: {
    game_id: string;
    score: number;
    won: boolean;
    time_spent: number;
  }) => trackEvent("game_play_completed", params),

  // Engagement
  gameFavorited: (gameId: string) => trackEvent("game_favorited", { game_id: gameId }),
  gameUnfavorited: (gameId: string) =>
    trackEvent("game_unfavorited", { game_id: gameId }),
  gameShared: (params: { game_id: string; recipients_count: number }) =>
    trackEvent("game_shared", params),
  shareAccepted: (params: { game_id: string; via: "existing_user" | "signup" }) =>
    trackEvent("share_accepted", params),
  leaderboardViewed: (scope: "game" | "global") =>
    trackEvent("leaderboard_viewed", { scope }),

  // KidGuard
  kidguardBlocked: (params: { reason: string; grade?: string }) =>
    trackEvent("kidguard_blocked", params),
} as const;
